/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { LegacyFinalUrlExpansion } from './legacy-final-url-expansion';


const LegacyFinalUrlExpansionWithCustomValidation = ({ validationProps, updateValidation, ...restProps }) => {
  const { data: finalUrlExpansions } = validationProps;

  const activity = useContext(ActivityContext);

  const i18n = useContext(I18nContext);
  const onChange = useCallback((newData) => {
    updateValidation([], newData);

    if (activity) {
      activity.signal(`onLegacyFinalUrlExpansionChange - ${JSON.stringify(newData)}`);
    }
  }, [updateValidation]);

  return (
    <LegacyFinalUrlExpansion
      level="campaign"
      onChange={onChange}
      data={finalUrlExpansions}
      i18n={i18n}
      {...restProps}
    />
  );
};

LegacyFinalUrlExpansionWithCustomValidation.propTypes = {
  validationProps: PropTypes.shape({
    data: PropTypes.shape({}),
  }).isRequired,
  updateValidation: PropTypes.func.isRequired,
};

export const ValidatedLegacyFinalUrlExpansion = withCustomValidation(LegacyFinalUrlExpansionWithCustomValidation);
